import React from 'react';

export function NOME(props) {
    return (
        <div>
            <div
                className={`${props.steps === 1 ? 'flex flex-col' : 'hidden'} text-lg text-gray-700`}
            >
                {props.NomeEmpresa}
            </div>
        </div>
    )

}